<button
  pButton
  [loading]="isLoading"
  class="w-full bg-white rounded-md p-4 flex items-center space-x-4 border-none md:border-[1px] md:border-solid md:border-light"
  (click)="redirectToClaims(claimsType, claimsRedirectValue)">
  <i
    [class]="logo"
    class="text-base"></i>
  <span class="font-bold text-base ml-4">{{ text | translate }}</span>
</button>
